import { auth } from "./../../../server";
import {
  getDBUser,
  getLoyaltyMember,
  getUserByPhoneNumber,
  UpdateCustomer,
  updateUser,
  userBuilder,
  verifyUserPhone,
} from "../../../api/services/userService.js";
import firebase from "firebase/compat/app";
import { delay } from "../../../api/helpers/commonHelpers";
import { onlineOrdering } from "@/constants/strings";
export default {
  state: {
    user: null,
    dbuser: null,
    showOverlay: false,
    //0:login 1:verification 2:register
    //0:login 1:verification 2:register
    overlayIndex: 0,
    redirectedFromCheckout: false,
    unsubscribeAutoSignIn: null,
    unsubscribeUserSignIn: null,
    unsubscribeGoogleSignIn: null,
    unsubscribeFacebookSignIn: null,
    unsubscribeUserSignUp: null,
    verificationPhone: null,
    phoneNumber: "",
    skipAuth: false,
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
    setDBUser(state, payload) {
      if (payload && payload.RewardPoints && !isNaN(payload.RewardPoints)) {
        payload.RewardPoints = Math.floor(payload.RewardPoints);
      }
      if (payload) {
        state.dbuser = { ...state.dbuser, ...payload };
      } else {
        state.dbuser = null;
      }
    },
    setShowOverlay(state, payload) {
      if (typeof payload == "object") {
        state.redirectedFromCheckout = true;
        state.showOverlay = payload.value;
      } else {
        state.showOverlay = payload;
        if (payload == true) {
          state.redirectedFromCheckout = false;
        } else {
          state.verificationPhone = null;
        }
      }
    },
    setOverlayIndex(state, payload) {
      state.overlayIndex = payload;
    },
    setSkipAuthentication(state, payload) {
      state.skipAuth = payload;
    },
    setVerificationPhone(state, payload) {
      state.verificationPhone = payload;
    },
    setUnsubscribeAutoSignIn(state, payload) {
      state.unsubscribeAutoSignIn = payload;
    },
    setUnsubscribeUserSignIn(state, payload) {
      state.unsubscribeUserSignIn = payload;
    },
    setUnsubscribeGoogleSignIn(state, payload) {
      state.unsubscribeGoogleSignIn = payload;
    },
    setUnsubscribeFacebookSignIn(state, payload) {
      state.unsubscribeFacebookSignIn = payload;
    },
    setUnsubscribeUserSignUp(state, payload) {
      state.unsubscribeUserSignUp = payload;
    },
    setPhoneNumber(state, payload) {
      state.phoneNumber = payload;
    },
  },
  actions: {
    async signUserUp({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        auth
          .createUserWithEmailAndPassword(payload.email, payload.password)
          .then(async (user) => {
            // commit("setLoading", false); this line causes an error
            dispatch("signUserIn", payload);
            resolve(user);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async signUserIn({ commit }, payload) {
      return new Promise(async (resolve, reject) => {
        auth
          .signInWithEmailAndPassword(payload.email, payload.password)
          .then(async (res) => {
            const newUser = {
              id: res.user.uid,
              name: res.user.displayName,
              email: res.user.email,
              address: res.user.address,
              phoneNumber: res.user.phoneNumber,
              birthDate: res.user.birthDate,
              photoUrl: res.user.photoURL,
              emailVerified: res.user.emailVerified,
            };
            commit("setUser", newUser);
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async signUserInFacebook({ commit, getters }) {
      return new Promise(async (resolve, reject) => {
        auth
          .signInWithPopup(new firebase.auth.FacebookAuthProvider())
          .then(async (user) => {
            const newUser = {
              id: user.uid,
              name: user.displayName,
              email: user.email,
              photoUrl: user.photoURL,
            };
            commit("setUser", newUser);
            var unsubscribeFacebookSignIn = getDBUser(newUser.id).onSnapshot(
              async (dbuser) => {
                if (dbuser.exists) {
                  let databaseUser = dbuser.data();
                  delete databaseUser.RewardPoints;
                  delete databaseUser.EarnedRewardPoints;
                  delete databaseUser.SpentRewardPoints;
                  commit("setDBUser", databaseUser);
                  resolve();
                } else {
                  UpdateCustomer(newUser.id, {
                    Email: newUser.email,
                    FirstName: newUser.name.split(" ")[0],
                    LastName:
                      newUser.name.split(" ")[1] || newUser.name.split(" ")[0],
                    HQCompanyID: getters.currentStoreDoc.HQCompanyID,
                  })
                    .then((response) => {
                      var customerCode = "";
                      if (response.data.Success) {
                        customerCode =
                          response.data.Customer.CustomerMemberCode;
                      }
                      updateUser(newUser.id, {
                        FirstName: newUser.name.split(" ")[0],
                        LastName:
                          newUser.name.split(" ")[1] ||
                          newUser.name.split(" ")[0],
                        DisplayName: newUser.name,
                        FirebaseUDID: newUser.id,
                        Email: newUser.email,
                        CustomerMemberCode: customerCode,

                        // pass source only for non branded stores
                        Source: !this.isBranded()
                          ? dbuser.Source
                            ? dbuser.Source
                            : onlineOrdering
                          : null,
                      });
                    })
                    .catch(() => {
                      resolve();
                    });
                }
              }
            );
            commit("setUnsubscribeFacebookSignIn", unsubscribeFacebookSignIn);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async signUserInGoogle({ commit, getters }) {
      return new Promise(async (resolve, reject) => {
        auth
          .signInWithPopup(new firebase.auth.GoogleAuthProvider())
          .then(async (res) => {
            var user = res.user;

            const newUser = {
              id: user.uid,
              name: user.displayName,
              email: user.email,
              photoUrl: user.photoURL,
            };
            commit("setUser", newUser);
            let dQuery = await getDBUser(newUser.id).get();
            if (!dQuery.exists) {
              await UpdateCustomer(newUser.id, {
                Email: newUser.email,
                FirstName: newUser.name.split(" ")[0],
                LastName: newUser.name.split(" ")[1] || "",
                HQCompanyID: getters.currentStoreDoc.HQCompanyID,
              });
              //wait for firestore to update doc
              await delay(200);
            }
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async autoSignIn({ commit, dispatch }, payload) {
      if (payload.email || payload.Mobile) {
        commit("setUser", {
          id: payload.uid,
          name: payload.displayName || "",
          email: payload.email || "",
        });
      }
      getDBUser(payload.uid).onSnapshot((dbuser) => {
        if (dbuser.exists && dbuser.data()) {
          const databaseUser = { ...dbuser.data() };
          if (databaseUser.Email || databaseUser.Mobile) {
            delete databaseUser.RewardPoints;
            delete databaseUser.EarnedRewardPoints;
            delete databaseUser.SpentRewardPoints;
            commit("setDBUser", databaseUser);
            dispatch("applyPriceTriggers");
            const userData = userBuilder({
              ...databaseUser,
              ...{ uid: payload.uid },
            });
            commit("setUser", userData);
          }
        }
      });
      dispatch("updateUserPoints");
    },
    updateUserPoints({ commit, getters }) {
      if (auth.currentUser) {
        getLoyaltyMember(
          getters.currentStoreDoc.HQCompanyID,
          auth.currentUser.phoneNumber,
          auth.currentUser.email
        ).then((user) => {
          commit("setDBUser", user);
        });
      }
    },
    async signUserInPhone({ commit, getters }, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          let { verificationId, verificationCode, userInfo } = payload;
          const credential = await firebase.auth.PhoneAuthProvider.credential(
            verificationId,
            verificationCode
          );
          let res = await auth.signInWithCredential(credential);
          await verifyUserPhone({ id: res.user.uid });
          if (!userInfo) {
            let userDoc = await getUserByPhoneNumber(res.user.phoneNumber);
            userInfo = userDoc
              ? {
                  Email: userDoc.Email,
                  FirstName: userDoc.FirstName,
                  LastName: userDoc.LastName,
                  HQCompanyID: getters.currentStoreDoc
                    ? getters.currentStoreDoc.HQCompanyID ||
                      getters.currentStoreDoc.ID
                    : null,
                }
              : {};
          }
          const { Email, FirstName, LastName } = userInfo || {};
          const userData = {
            id: res.user.uid,
            name: `${FirstName || ""} ${LastName || ""}`.trim(),
            email: Email || "",
            phoneNumber: res.user.phoneNumber,
            emailVerified: res.user.emailVerified,
          };
          const updateUserResult = await UpdateCustomer(userData.id, {
            Email: userData.email,
            FirstName: FirstName || "",
            LastName: LastName || "",
            Mobile: userData.phoneNumber,
            HQCompanyID: getters.currentStoreDoc.HQCompanyID,
          });
          if (!updateUserResult.data.Success) {
            throw new Error(updateUserResult.data.Status.Message);
          }
          commit("setUser", userData);
          resolve(res);
        } catch (error) {
          reject(error);
        }
      });
    },
    resetPasswordWithEmail(payload) {
      const { email } = payload;
      auth.sendPasswordResetEmail(email).then(() => {
        throw "Email Sent";
      });
    },
    async logout({ commit, state }) {
      unsubscribing(state);
      await auth.signOut();
      commit("setUser", null);
      commit("setDBUser", null);
    },

    setPhoneNumber({ commit }, payload) {
      commit("setPhoneNumber", payload);
    },
    setOverlayIndex({ commit }, payload) {
      commit("setOverlayIndex", payload);
    },
    setSkipAuthentication({ commit }, payload) {
      commit("setSkipAuthentication", payload);
    },
  },

  getters: {
    user(state) {
      return state.user;
    },
    dbuser(state) {
      return state.dbuser;
    },
    showOverlay(state) {
      return state.showOverlay;
    },
    verificationPhone(state) {
      return state.verificationPhone;
    },
    redirectedFromCheckout(state) {
      return state.redirectedFromCheckout;
    },
    phoneNumber(state) {
      return state.phoneNumber;
    },
    getOverlayIndex(state) {
      return state.overlayIndex;
    },
    getSkipAuthentication(state) {
      return state.skipAuth;
    },
  },
};
function unsubscribing(state) {
  if (state.unsubscribeAutoSignIn) state.unsubscribeAutoSignIn();
  if (state.unsubscribeFacebookSignIn) state.unsubscribeFacebookSignIn();
  if (state.unsubscribeGoogleSignIn) state.unsubscribeGoogleSignIn();
  if (state.unsubscribeUserSignIn) state.unsubscribeUserSignIn();
  if (state.unsubscribeUserSignUp) state.unsubscribeUserSignUp();
}
